import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';
import { Link, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../store';
import dictionariesActions from '../../store/Dictionaries';

export default function Select() {
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const auth = useAppSelector(state => state.auth);
    const dictionariesStore = useAppSelector(state => state.dictionaries);
    const choiceTrainingAvailable = useAppSelector(state => state.stat?.modeStat?.choiceTrainingAvailable) || !auth.user;
    const isPreview = searchParams.get('preview') === 'true';

    React.useEffect(() => {
        document.title = (document as any).rootTitle;
        if (!auth.user && dictionariesStore.dictionaries?.length === 1)
            dispatch(dictionariesActions.getDictionaries());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onDictionaryChange(e: ChangeEvent<HTMLSelectElement>) {
        dispatch(dictionariesActions.select(parseInt(e.target.value)));
    }

    return (
        <div className="width-limit d-block d-md-flex flex-grow-1 flex-column align-items-center w-100"
            style={{
                paddingTop: 'calc(min(40vh, 50vw) - 25rem)'
            }}>

            {isPreview &&
                <h5>Preview of new cards</h5>
            }

            {!auth.user &&
                <>
                    <p><Link to="signin" className="btn btn-sm btn-outline-primary me-1">Sign in</Link> to save your progress</p>

                    <Form.Select
                        id="dictionaryId"
                        name="dictionaryId"
                        value={dictionariesStore.dictionaryId}
                        className="my-4 mx-auto"
                        style={{ maxWidth: '400px' }}
                        onChange={onDictionaryChange}>
                        {dictionariesStore.dictionaries?.map(d =>
                            <option value={d.id} key={d.id}>{d.name}</option>)}
                    </Form.Select>
                </>
            }

            <div className="row g-3 mb-3">
                <div className="col-12 col-md-6">
                    <Link to='/recollect'
                        className='text-decoration-none btn btn-light btn-lg'>
                        <h2>Recollect or choose</h2>
                        <p className="fs-5">Recollect the meaning and assess your knowledge. If you cannot recollect you can show the options.</p>
                    </Link>
                </div>

                <div className="col-12 col-md-6">
                    <Link to='/choice'
                        className={'text-decoration-none btn btn-light btn-lg' + (choiceTrainingAvailable ? '' : ' disabled')}>
                        <h2>Choose the right option</h2>
                        <p className="fs-5">Choose the right meaning of the phrase from four options. Use this mode to review many cards quickly.</p>
                    </Link>
                </div>

                {auth.user &&
                    <>
                        <div className="col-12 col-md-6">
                            <Link to='/auto'
                                className={'text-decoration-none btn btn-light btn-lg' + (choiceTrainingAvailable ? '' : ' disabled')}>
                                <h2>Automatic</h2>
                                <p className="fs-5">The type of training ("Recollect" or "Choose") is automatically selected depending on the strength of a card</p>
                            </Link>
                        </div>

                        <div className="col-12 col-md-6">
                            <Link to='/preview'
                                className="text-decoration-none btn btn-light btn-lg">
                                <h2>Preview of new cards</h2>
                                <p className="fs-5">Preview new cards and assess their knowledge, preparing them to active studying</p>
                            </Link>
                        </div>

                        <div className="col-12 col-md-6">
                            <Link to='/hard'
                                className="text-decoration-none btn btn-light btn-lg">
                                <h2>Review of hard cards</h2>
                                <p className="fs-5">Review the cards in on-hold state or the cards which happened to be hard to remember</p>
                            </Link>
                        </div>
                    </>
                }
            </div>
        </div>
    );
}
